import FieldSelect from './fields/fieldSelect';
import React from 'react';
import api from '../apiConnector.js';


export default class FrontSelectVehiculeAuto extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            vehiculier:false,
            versions:false
        }
    }

    componentDidMount() {
        api.post({
            action:'get_vehiculier_auto'
        }, (res)=>{ 
                this.setState({vehiculier:JSON.parse(res.vehiculier_auto)})
            }
        )
        this.updateVersionList()
    }

    componentDidUpdate(prevProps) {
        const prevParams = prevProps.container.devis.params
        const params = this.props.container.devis.params
        if (( prevParams.marque != params.marque )||( prevParams.modele != params.modele )) {
            this.updateVersionList()
        }
    }

    updateVersionList() {
        const {marque,modele,sra} = this.props.container.devis.params
        let newSra = sra
        this.setState({versions:false})
        if ( marque && modele ) {
            api.post({
                action:'get_vehiculier_auto_versions',
                marque:marque,
                modele:modele
            }, (res)=>{ 
                    this.setState({versions:res.versions})
                    if ( newSra &&( !res.versions.find( v=>(v.sra==newSra) ) )) {
                        newSra = false
                    }
                    if ( !newSra ) {
                        const vEmpty = res.versions.find( v => ( v.version == '-' ))
                        if ( vEmpty ) newSra = vEmpty.sra
                    }
                    if ( newSra != sra ) {
                        console.log('Change SRA',sra,newSra)
                        this.props.changeParams({sra:newSra})
                    }
                }
            )
        } else this.setState({versions:false})
    }

    optionsMarque() {
        return this.state.vehiculier 
            ? Object.keys( this.state.vehiculier ).map( m => ({value:m,label:m}) )
            : []
    }

    optionsModele() {
        const {marque} = this.props.container.devis.params
        return ( this.state.vehiculier && marque && this.state.vehiculier[marque] )
            ? this.state.vehiculier[marque].map( m => ({value:m,label:m}))
            : []
    }

    optionsVersions() {
        const cont = (s,pr='',p='') => ( s &&( s != '-' ) ) ? pr+s+p+' ' : ''
        return this.state.versions ? this.state.versions.map( v => 
            ({ value:v.sra, label:cont(v.version)+cont(v.generation)+cont(v.energie,'- ')+cont(v.carrosserie,'- ')+cont(v.pa,'- ',' CV') } ) ) : []
    }

    render() {
        const {container} = this.props
        return <>
            <FieldSelect field="marque" container={container} options={this.optionsMarque()}/>
            <FieldSelect field="modele" container={container} options={this.optionsModele()}/>
            <FieldSelect field="sra" container={container} options={this.optionsVersions()}
                label="Version"/>
        </>
    }
}
